import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import { ArrowLeftIcon, SendIcon } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { Input } from '@/components/ui/input';

const sharefileFormSchema = z.object({
  email: z.string().min(1, "Enter the contact's email address").email('Invalid email address'),
});

export type ISharefileForm = z.infer<typeof sharefileFormSchema>;

type Props = {
  onSubmit: (data: ISharefileForm) => void;
  onBack: () => void;
};

const SharefileForm = ({ onSubmit, onBack }: Props) => {
  const form = useForm<ISharefileForm>({
    resolver: zodResolver(sharefileFormSchema),
    defaultValues: {
      email: '',
    },
  });

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6">
        <FormField
          control={form.control}
          name="email"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Email address</FormLabel>
              <FormControl>
                <Input {...field} placeholder="Enter email address" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <div className="flex flex-col sm:flex-row gap-4 sm:gap-6">
          <Button size="sm" variant="outline" className="sm:flex-1" onClick={onBack}>
            <ArrowLeftIcon /> View instructions
          </Button>
          <Button
            type="submit"
            size="sm"
            isLoading={form.formState.isSubmitting}
            disabled={form.formState.isSubmitting}
            className="sm:flex-1"
          >
            Submit <SendIcon />
          </Button>
        </div>
      </form>
    </Form>
  );
};

export default SharefileForm;
